const startCaseCapitalLetter = (string) => {
  if (string && typeof string === "string")
    return (
      string.slice(0, 1).toLocaleUpperCase() + string.slice(1, string.length)
    );
  else return "";
};

export { startCaseCapitalLetter };
